export default __webpack_public_path__ + "static/GoW_Omen_Red-d189ca5eb4a0bf09aea63b2132926839.svg";